import React, { RefObject } from "react";
import { Svg } from "../../../../Shared/Assets/Svg/React";
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonType
} from "../../../../Shared/Buttons/React";
import { Modal } from "../../../../Shared/Modal/React";
import { useProvetStatic, useTranslationContext } from "../../context";
import { formatAppointmentDate, formatAppointmentTime } from "../../utilities";

interface ProvetCancelBookingModalProps {
  active: boolean;
  appointmentTime?: string;
  appointmentDate?: string;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  contentRef: RefObject<HTMLDivElement>;
  modalRef?: RefObject<HTMLDivElement>;
}

export const ProvetCancelBookingModal = ({
  active,
  appointmentTime,
  appointmentDate,
  isLoading,
  onConfirm,
  onCancel,
  contentRef,
  modalRef
}: ProvetCancelBookingModalProps) => {
  const translationContext = useTranslationContext();
  // The site language, so that the date is not shown in the browser's or default language
  const { language } = useProvetStatic();
  const translations = translationContext?.translations;
  const titleId = "provet-cancel-booking-modal-title";

  const date = appointmentDate ? formatAppointmentDate(appointmentDate, language) : "";
  const time = appointmentTime ? formatAppointmentTime(appointmentTime) : "";

  return (
    <Modal
      active={active}
      onClose={onCancel}
      hasFooter={false}
      ref={modalRef}
      titleId={titleId}
      modalName="cancelBooking"
    >
      {/* Modal Header */}
      <div ref={contentRef} className="flex flex-col gap-2xl w-full text-t-neutral-800">
        <div className="flex flex-col gap-md">
          <h2
            id={titleId}
            className="flex items-center font-guardian text-dark-blue text-t-md sm:text-t-xl font-t-semi-bold leading-lg sm:leading-xxl gap-xs md:gap-sm"
          >
            <Svg href="/dist/sprite.svg#sys-info" additionalClass="fill-t-neutral-700" />
            {translations?.cancelBooking}
          </h2>
        </div>
      </div>
      {/* Modal Content */}
      <div className="mt-md">
        <p className="text-md md:text-lg text-t-neutral-800">
          {translations?.cancelConfirmationMessage} {date} {time}?
        </p>
      </div>
      <div className="flex flex-col gap-md sm:flex-row mt-2xl">
        <Button
          type={ButtonType.Button}
          size={ButtonSize.LG}
          color={ButtonColor.Pink}
          onClick={onConfirm}
          disabled={isLoading}
          isLoading={isLoading}
          data-online-booking-action="confirm"
        >
          {isLoading ? translations?.cancellingBooking : translations?.cancelYes}
        </Button>
        <Button
          type={ButtonType.Button}
          size={ButtonSize.LG}
          color={ButtonColor.OutlineNeutral}
          onClick={onCancel}
          disabled={isLoading}
          data-online-booking-action="cancel"
        >
          {translations?.cancelNo}
        </Button>
      </div>
    </Modal>
  );
};
